import { Component, OnInit, Renderer2, Type as AngularCoreType } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ShowToHideFromComponent } from '../show-to-hide-from/show-to-hide-from.component';

@Component({
    selector: 'app-mark-data-readonly',
    templateUrl: '../show-to-hide-from/show-to-hide-from.component.html', //'./mark-data-readonly.component.html',
    styleUrls: ['./mark-data-readonly.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: MarkDataReadOnlyComponent,
            multi: true
        }
    ],
    standalone: false
})
export class MarkDataReadOnlyComponent extends ShowToHideFromComponent implements OnInit {
    // Constructor.
    public constructor(renderer: Renderer2) {
        super(renderer);
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Emit my properties.
        let hshOnInitProperties = this.getProperties();
        this.onInit.emit(hshOnInitProperties);
    }

    // Override the method used to get my class.
    public getFormFieldClass(): AngularCoreType<any> {
        return MarkDataReadOnlyComponent;
    }

    // Override some base class methods.
    public get FieldTypeName(): string {
        return 'Mark Data Read-only';
    }

    /*
    public get DescriptiveDisplayName(): string {
        let name: string = '';

        if (this.FormField.isConditionalBeginElement)
            name = `${this.BeginOrEndTag} ${this.FieldTypeName}: ${this.DisplayName}`;
        else {
            if (this.FormField.transientMatchingBeginOrEndField != null) {
                if (!StringUtil.isEmptyString(this.FormField.transientMatchingBeginOrEndField.displayName))
                    name = `${this.BeginOrEndTag} ${this.FieldTypeName}: ${this.FormField.transientMatchingBeginOrEndField.displayName}`;
                else
                    name = `${this.BeginOrEndTag} ${this.FieldTypeName}: ${this.FormField.transientMatchingBeginOrEndField.name}`;
            } else if (this.FormField.transientBeginFieldDisplayName != null) {
                name = `${this.BeginOrEndTag} ${this.FieldTypeName}: ${this.FormField.transientBeginFieldDisplayName}`;
            } else {
                //name = `this.formField.transientMatchingBeginOrEndField is null!`;
                if (this.FormField.transientMatchingBeginOrEndField != null)
                    name = `${this.BeginOrEndTag} ${this.FieldTypeName}: ${this.FormField.transientMatchingBeginOrEndField.name}`;
                else
                    name = 'Matching begin or end field error';
            }
        }            

        return name;
    }
    */
}
